import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth';
import { ROUTES } from '@/config/routes';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    // 로딩 중이 아니고, 인증되지 않았으며, 사용자 정보가 없을 때 로그인 페이지로 리다이렉트
    if (!isLoading && !isAuthenticated && !user) {
      console.log('[ProtectedRoute] 인증되지 않은 사용자, 로그인 페이지로 리다이렉트');
      navigate(ROUTES.SIGNIN, { replace: true });
    }
  }, [isAuthenticated, user, isLoading, navigate]);

  // 로딩 중일 때 로딩 화면 표시
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">인증 확인 중...</h2>
          <p className="text-gray-500">잠시만 기다려 주세요.</p>
        </div>
      </div>
    );
  }

  // 인증되지 않은 경우 빈 화면 (리다이렉트가 진행되는 동안)
  if (!isAuthenticated || !user) {
    return null;
  }

  // 인증된 경우 자식 컴포넌트 렌더링
  return <>{children}</>;
}